<script>
import { markAsClickedNotification, readNotification } from '@src/api/notifications'

export default {
  page: {
    title: 'Redirecting...',
    meta: [
      {
        name: 'description',
        content: 'Redirecting...',
      },
    ],
  },
  created() {
    this.readNotificationAndRedirect()
  },
  methods: {
    async readNotificationAndRedirect() {
      const newUrl = this.$route.query?.redirect
      const notificationId = this.$route.query?.id || 0
      try {
        await readNotification({ id: notificationId })
        if (newUrl) {
          await markAsClickedNotification({ id: notificationId })
        }
      } catch (e) {
      } finally {
        if (!newUrl) {
          await this.$router.push({
            name: 'home',
          })
        }

        window.open(newUrl, '_self')
      }
    },
  },
}
</script>

<template>
  <Transition appear>
    <BaseIcon class="m-auto d-block" name="spinner" spin />
  </Transition>
</template>

<style lang="scss" module>
@import '@design';
</style>
